module.exports = __webpack_public_path__ + "public/media/real.png";


//////////////////
// WEBPACK FOOTER
// ./images/partners/real.png
// module id = ./images/partners/real.png
// module chunks = 0